export function saveLicenseKeyToFile(licenseKey: string) {
    const domain = window.location.hostname;
    const url = window.location.origin;
    const date = new Date().toISOString().split('T')[0];
    const content = `${domain} LICENSE KEY:

${licenseKey}

activate it this way: ${url}/?license_key=${licenseKey}

Questions? Ping us at hello@kick-video.download

Cheers!


####################
####################
########        ########
########        ########
########            ########
########            ########
########            ########
########            ########
########            ########
########            ########
########        ########
########        ########
####################
####################
`;
    const blob = new Blob([content], {type: "text/plain"});
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = `license-key-${domain}-${date}.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
}
